"use client";

import type { LandingPage } from "@/lib/types/landingPage";
import { SLHtmlFromLangFile } from "../sections/home/SLHtmlFromLangFile";
import { SLPreviewCard } from "./SLPreviewCard";

interface SLLandingpagePreviewCardProps {
  landingpage: LandingPage;
}

export const SLLandingpagePreviewCard = ({
  landingpage,
}: SLLandingpagePreviewCardProps) => {
  return (
    <SLPreviewCard
      href={landingpage.href}
      title={
        <SLHtmlFromLangFile htmlString={landingpage.landingpageString.title} />
      }
      summary={
        <SLHtmlFromLangFile
          htmlString={landingpage.landingpageString.summary[0]}
        />
      }
    />
  );
};
